<template>
  <layout-default-filters @open="$_OnOpen" @apply="$_applyQueryString" :hideButton="false">
    <template #superior>
    <div class='div-geral'>
      <div class='segundo-filtro'>
        <div class='radios'>
          <v-radio-group v-model="radioGroup" row>
            <v-radio
              v-for="n in 2"
              :key="n"
              :label="radioLabel[n - 1]"
              :value="n"
            ></v-radio>
          </v-radio-group>
        </div>
        <core-text-field 
          clearable 
          class='txt-filter' 
          @focus='toggleFilter(true)'
          @keydown.enter="$_load(1)" 
          v-model="nomevendedor"
          min="0"
          @keydown="bloquearCaracteresInvalidos"
          @input="garantirPositivo()"
          label='Pesquisar Vendedor'
          :type='inputType'
        />
        <div class='btns-wrap'>
          <v-btn rounded color='primary' class='btns opacity-switch' @click='$_load(0)'>
            <v-icon>mdi-arrow-left-thick</v-icon>
          </v-btn>
          <v-btn rounded color='primary' class='btns opacity-switch reducesize' @click='$_load(1)'>
            <v-icon>mdi-arrow-left-thick</v-icon><v-icon>mdi-arrow-right-thick</v-icon>
          </v-btn>
          <v-btn rounded color='primary' class='btns-mini opacity-switch' @click='toggleFilter(false)'>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <template>
        <v-divider></v-divider>
          <div class="mx-auto cardlist" max-width="500" v-if='filtroInicial'>
            <v-list two-line class='scroll'>
              <v-list-item-group active-class="green--text" multiple>
                <template v-for="(item, index) in items">
                  <v-list-item :key="index">
                    <v-card class='cardpessoa' @click="$_onClickCard(item)">
                      <v-card-text class="pa-2">
                        <strong>{{ item.codigo }}</strong> - {{ item.descricao }}
                      </v-card-text>
                    </v-card>
                  </v-list-item>
                  <v-divider v-if="index < items.length - 1" :key="`div-${index}`"></v-divider>
                </template>
              </v-list-item-group>
            </v-list>
          </div>
          <v-divider></v-divider>
        </template>
      </div>
    </div>
    </template>
  </layout-default-filters>
</template>

<script>
import { mapMutations } from 'vuex';
import db from '@/plugins/dexie';
import { getQueryValue, setQueryValue } from '@/services/query-string';
import LayoutDefaultFilters from '@/layouts/default/NewFilters.vue';
import CoreTextField from '@/components/core/text-field/Index.vue';
import errorHandler from '@/utils/error-handler';
import storage from '@/services/storage';

export default {
  name: 'ViewVendedorFilters',

  components: {
    LayoutDefaultFilters,
    CoreTextField,
  },

  data() {
    return {
      items: [],
      radioGroup: 2,
      radioLabel: ['Código', 'Nome'],
      nomevendedor: null, 
      filtroInicial: false,
      inputType: 'text',
      loading: false,
      filters: {
        codigopessoa: null,
      },
      
      config: {
        collection: db.vendedor,
        idKey: 'venidnuvem',
        descKey: 'vennome'
      }
    };
  },

  methods: {
    ...mapMutations({
      $_setRefresh: 'filter/refresh',
    }),

    garantirPositivo() {
      if (this.nomevendedor && this.nomevendedor < 0) {
        this.nomevendedor = Math.abs(this.nomevendedor).toString();
      }
    },

    bloquearCaracteresInvalidos(e) {
      if (['-', '+'].includes(e.key)) {
        e.preventDefault();
      }
    },

    async $_load(parametroLoad) {
      this.loading = true;
      try {
        if (parametroLoad === 2) {
          this.nomevendedor = null;
          this.filters.codigopessoa = null;
          storage.setItem('pesquisaTextoFiltro', '');
          this.toggleFilter(false);
          this.items = [];
          this.$_applyQueryString();
          return;
        }

        let queryData;
        const termoPesquisa = this.nomevendedor ? this.nomevendedor.toString().trim() : '';

        if (termoPesquisa === '') {
          this.filters.codigopessoa = null; 
          storage.setItem('pesquisaTextoFiltro', '');
          
          queryData = await this.config.collection.limit(100).toArray();
        
        } else {
          if (this.radioGroup === 2) {
            // Busca por Nome
            queryData = await this.config.collection
              .where(this.config.descKey)
              .startsWithIgnoreCase(termoPesquisa)
              .limit(100)
              .toArray();
          } else {
            // Busca por Código
            const valorBusca = parseInt(termoPesquisa);
            if (!isNaN(valorBusca)) {
              queryData = await this.config.collection
                .where(this.config.idKey)
                .equals(valorBusca)
                .limit(100)
                .toArray();
            } else {
              queryData = await this.config.collection
                .where(this.config.idKey)
                .equals(termoPesquisa)
                .limit(100)
                .toArray();
            }
          }
        }

        this.items = queryData.map(item => {
          return {
            codigo: item[this.config.idKey],
            descricao: item[this.config.descKey],
            original: item 
          };
        });
        
        if (this.items.length > 0) {
            this.toggleFilter(true);
        }

      } catch (err) {
        errorHandler.call(this, err);
        this.items = [];
      } finally {
        this.loading = false;
      }
    },

    $_applyQueryString() {
      if (!this.nomevendedor || this.nomevendedor.toString().trim() === '') {
          this.filters.codigopessoa = null;
          storage.setItem('pesquisaTextoFiltro', '');
      }

      const valorAtualNaUrl = this.$route.query.codigo;
      const novoValor = this.filters.codigopessoa;

      const strAtual = String(valorAtualNaUrl || '');
      const strNovo = String(novoValor || '');

      if (strAtual !== strNovo) {
          setQueryValue('codigo', novoValor ? novoValor : null); 
          this.$_setRefresh('S');
      }
    },

    $_OnOpen() {
      // Vazio: só carrega se clicar na lupa/enter
    },

    toggleFilter(show) {
      const opacity = document.querySelectorAll('.opacity-switch');
      this.filtroInicial = show;
      opacity.forEach(el => el.style.opacity = show ? '1' : '0');
    },

    $_onClickCard(item) {
      if (this.filtroInicial) {
        this.nomevendedor = `${item.codigo} - ${item.descricao}`;
        storage.setItem('pesquisaTextoFiltro', this.nomevendedor);

        this.filters.codigopessoa = item.codigo;

        this.toggleFilter(false);
      }
    },
  },

  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler() {
        this.filters.codigopessoa = getQueryValue('codigo', null);
        this.nomevendedor = null; 
        storage.setItem('pesquisaTextoFiltro', '');
        
        this.toggleFilter(false);
        this.items = [];
      },
    },
  },
};
</script>

<style scoped>
  .btns-wrap {
    display: flex;
    justify-content: space-around;
    height: 50px;
  }
  .opacity-switch {
    transition: opacity 0.3s;
  }
  .btns {
    width: 33%;
    transition: opacity 0.3s;
    opacity: 0;
  }
  .btns-mini {
    width: 10%;
    transition: opacity 0.3s;
    opacity: 0;
  }
  .segundo-filtro {
    position: relative;
  }
  .radios {
    transition: opacity 0.3s;
  }
  .mx-auto.cardlist {
    transition: opacity 0.3s, top 0.4s;
    height: 50vh;
    overflow-y: scroll;
    background-color: rgb(245, 245, 245);
  }
  .cardpessoa {
    height: 80px;
    width: 100%;
    margin-top: 5px;
  }
  .txt-filter {
    height: 50px;
  }
</style>